import useContentStatusStore from './contentStatusStore';
import useContentCountStore from './contentCountStore';
import LibraryService from '~/services/apis/LibraryService';

async function setupContentStatusStore(limit: number) {
  const { setContentLimitExceedThreshold } = useContentStatusStore();
  setContentLimitExceedThreshold(limit);
  await fetchAndSetContentCounts();
}

async function fetchAndSetContentCounts() {
  const { setContentCounts, startLoading, endLoading, markStoreAsInitialised, countsInitialised } = useContentCountStore();
  if (!countsInitialised) {
    startLoading();
  }
  const counts = await LibraryService.getQuizzesCount();
  if (!countsInitialised) {
    endLoading();
  }
  markStoreAsInitialised();
  setContentCounts(counts);
  return counts;
}

export default setupContentStatusStore;
export {
  fetchAndSetContentCounts,
};
